import { BaseService } from "./BaseService";
import { SnackBarModule } from "../modules/SnackBarModule";

export const ConvocarFeriasService = {
  async postConvocarFerias(postData) {

    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/convocacao`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message, "error");
      return false;
    }
    SnackBarModule(await response.message, "success");

    return response.message;
  },

  async getByIdFerias(id) {
    const response = await BaseService.fetchResponseFromAPIGet(`civil/analisarconvocacaoferias/${id}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao consultar as informações deste item", "error");
    }
    return response.content;
  },

  async aprovarConvocacaoFerias(id,postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analisarconvocacaoferias/aprovar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule(await response.message, "success");
    return true;
  },

  async recusarConvocacaoFerias(id,postData) {
    const response = await BaseService.fetchResponseFromAPIPost(
      `civil/analisarconvocacaoferias/recusar/${id}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(await response.message.message, "error");
      return false;
    }
    SnackBarModule("Convocação recusada com sucesso.", "success");
    return true;
  },
}